import { io } from "socket.io-client";

const socket = io("/", {
  withCredentials: true
});

socket.on("connect", () => {
  //console.log("✅ Socket.IO connected:", socket.id);
});

socket.on("connect_error", (err) => {
  console.error("❌ Socket.IO connect error:", err.message);
});

export default socket;
